import { ApplicationElement } from '../application_element/element.js';
import CommonActions from '../common_actions/element.js';
import translations from './translations.js';
import '../icon_block/element.js';

/**
 * Item of a dot menu - does not have its own render - it will look however the platforms dot menu item looks.
 *
 * @prop name - Item name/title
 * @prop icon - Item icon
 * @prop url - Item's action URL
 * @prop urlMethod - Method that is invoked on item click, optional (options: visit, execJSFromResponse, get, post, patch, put, delete)
 * @prop confirmMessage - Message shown for actions that require user confirmation. If not passed, no confirmation is asked for (optional)
 * @prop successMessage - Message shown after the action is completed successfully (optional)
 * @prop errorMessage - Message shown after the action is fails (optional)
 * @prop isDivider - Is this item a divider? If true, all other properties are obsolete (optional)
 * @prop itemRole - Will be used in dot-menu-2 and converted to buttons role (optional)
 */

export default class DotMenuItem extends ApplicationElement {
  static properties = {
    name: { type: String },
    icon: { type: String },
    isDivider: { type: Boolean },
    itemRole: { type: String },
    url: { type: String },
    urlMethod: { type: String },
    confirmMessage: { type: String },
    successMessage: { type: String },
    errorMessage: { type: String },
  };

  /** @internal */
  static translations = translations;

  constructor() {
    super();
    this.commonActions = new CommonActions(this);
    this.errorMessage = this.t('generic_error');
    this.urlMethod = 'visit';
  }

  confirm() {
    if (this.confirmMessage)
      return this.commonActions.confirmDialog(this.confirmMessage);
    return true;
  }

  snackSuccess() {
    if (this.successMessage)
      this.commonActions.displaySnackBarSuccess(this.successMessage);
  }

  snackError() {
    if (this.errorMessage)
      this.commonActions.displaySnackBarError(this.errorMessage);
  }

  async handleClick() {
    try {
      if (this.isDivider || !this.confirm()) return false;
      await this.commonActions[this.urlMethod](this.url);
      this.snackSuccess();
    } catch {
      this.snackError();
    }
  }
}

DotMenuItem.registerTagName('ef-dot-menu-item');

customElements.get('ef-dot-menu-item') ||
  customElements.define('ef-dot-menu-item', DotMenuItem);
